import 'flatpickr/dist/flatpickr.min.css';

export { default } from './datepicker'; // eslint-disable-line
